import type { Drug } from "../../types";

export const tirzepatideDrug: Drug = {
  id: "tirzepatide",
  name: "Tirzepatide (Mounjaro®)",
  drugClass: "GLP-1/GIP dual receptor agonist",
  route: "subcutaneous",
  defaultFoodTiming: "May be administered at any time of day, with or without food",
  formulations: [
    {
      id: "tirzepatide-2_5mg-pen",
      type: "prefilled_pen",
      strength: 2.5,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "5024151e-328e-4e9a-8315-eb0686ba9164",
    },
    {
      id: "tirzepatide-5mg-pen",
      type: "prefilled_pen",
      strength: 5,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "d8332b1d-1009-4066-9291-c62a55d98c1b",
    },
    {
      id: "tirzepatide-7_5mg-pen",
      type: "prefilled_pen",
      strength: 7.5,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "e7e17093-37ef-4a90-90cf-3c12dc25742c",
    },
    {
      id: "tirzepatide-10mg-pen",
      type: "prefilled_pen",
      strength: 10,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "f0e40f69-1afa-4d20-8cd9-aa3cf27a72f0",
    },
    {
      id: "tirzepatide-12_5mg-pen",
      type: "prefilled_pen",
      strength: 12.5,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "6d654f9d-b1a8-4a0e-a10c-454b23f02083",
    },
    {
      id: "tirzepatide-15mg-pen",
      type: "prefilled_pen",
      strength: 15,
      strengthUnit: "mg",
      storageNote: "Store at 2–8°C. Protect from light. Do not freeze. After first use may be stored at or below 30°C for up to 30 days.",
      prescribedItemId: "c6048448-9341-463b-860e-c005e0807053",
    },
  ],
};
